
import Vue from "vue";
import {Address, AddressType, Contact, contactApi, ContactPerson} from "@/api/contacts";
import { ValidationProvider } from "vee-validate";
import EventBus from "@/utils/EventBus";
import {SnackbarMsgEvent} from "@/layout/Layout.vue";
// eslint-disable-next-line
const ContactAddress: any = Vue.extend({
  name: "ContactAddress",
  components: {
    ValidationProvider,
  },
  props: {
    address: {
      type: Object as () => Address,
      required: false,
    },
    addressRef: {
      type: String,
      required: false,
    },
    contact: {
      type: Object as () => Contact,
      required: false,
    },
    contactRef: {
      type: String,
      required: false,
    },
    addressIndex: {
      type: Number,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentAddress: {} as Address,
      init: true,
      contactPersons: [] as ContactPerson[]
    };
  },
  computed: {
    addressTypes(): { value: string; text: string }[] {
      return Object.keys(AddressType).map((k) => ({
        value: k,
        text: this.$t(`enum.addressType.${k}`) as string,
      }));
    },
  },
  watch: {
    contact: {
      handler: async function () {
        if (this.contact) {
          this.contactPersons = [];
          this.contactPersons.push(...this.contact.contactPersons);
          this.contactPersons.push(...this.contact.externalContactPersons);
        }
      },
      immediate: true,
    },
    address: {
      handler: async function () {
        if (this.address) {
          this.currentAddress = this.address;
          this.init = false;
        }
      },
      immediate: true,
    },
    addressRef: {
      handler: function () {
        if (this.addressRef && this.contactRef) {
          contactApi
            .getAddressById(this.contactRef, this.addressRef)
            .then((result: Address) => {
              this.currentAddress = result;
            });
        }
      },
      immediate: true,
    },
    contactRef: {
      handler: function () {
        if (this.addressRef && this.contactRef) {
          contactApi
            .getAddressById(this.contactRef, this.addressRef)
            .then((result: Address) => {
              this.currentAddress = result;
            });
        }
      },
      immediate: true,
    },
  },
  methods: {
    copyToClipboard() {
      if( this.currentAddress) {
        let text = this.currentAddress.street+"\r\n";
            if( this.currentAddress.additionalAddress) {
              text += this.currentAddress.additionalAddress+"\r\n";
            }
            
           text += this.currentAddress.zipCode+" "+this.currentAddress.city+"\r\n";
        if( this.currentAddress.country || this.currentAddress.state ) {
          text += this.currentAddress.state + " " + this.currentAddress.country +"\r\n";
        }

        if( this.currentAddress.alternativeGP ) {
          text += this.currentAddress.alternativeGP +"\r\n";
        }

        navigator.clipboard.writeText(text).then(function() {
          EventBus.$emit("snackbarInfosTo", { msg: "Adresse erfolgreich kopiert" } as SnackbarMsgEvent);
        }, function(err) {
          EventBus.$emit("snackbarInfosTo",  { msg:"Adresse konnte nicht kopiert werden "+err } as SnackbarMsgEvent);
        });
      }
    },
    isNotOwnAddress() {
      return (
        this.currentAddress.shareable &&
        this.currentAddress.contactRef != undefined &&
        (this.currentAddress.contactRef !== this.contactRef || this.currentAddress.contactRef !== this.contact?.id)
      );
    },
    getAddressTypeIcon(addressType: AddressType) {
      if (addressType === AddressType.HOME) {
        return "mdi-map-marker-star";
      } else if (addressType === AddressType.BUSINESS) {
        return "mdi-office-building-marker";
      } else if (addressType === AddressType.COTTAGE) {
        return "mdi-image-filter-hdr";
      }
      return "mdi-map-marker";
    },
    fireChangeEvent() {
      this.$emit("change", this.currentAddress);
    },
    removeAddress() {
      this.$emit("removeAddress");
    },
  },
});
export default ContactAddress;
